import { render, staticRenderFns } from "./DataBlock.vue?vue&type=template&id=7cb8701a&"
import script from "./DataBlock.vue?vue&type=script&lang=js&"
export * from "./DataBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports